export default "__VITE_ASSET__BEw1FcGR__"